import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getUserRole } from "./auth";
import { useSelector } from "react-redux";
import useAuthCheck from "../hooks/useAuthCheck";

const ProtectedRoute = ({ children, allowedRoles, checkSubscription }) => {
  const isAuth = isAuthenticated();
  const userRole = getUserRole();
  const user = useSelector((state) => state?.AuthSlice?.user);

  useAuthCheck();

  if (isAuth && !allowedRoles) {
    const redirectPath =
      userRole === "corporate"
        ? "/corporate/dashboard"
        : userRole === "professional"
          ? "/professional/services"
          : userRole === "admin"
            ? "/admin/dashboard"
            : userRole === "employee"
            ? "/employee/chat"
            : userRole === "user"
              ? "/user/chat"
              : !userRole
                ? "/signin"
                : "/";

    return <Navigate to={redirectPath} />;
  }

  // Redirect unauthorized users
  if (!isAuth || !allowedRoles?.includes(userRole)) {

  }

  if (
    checkSubscription &&
    (!user?.subscription ||
      (user.subscription.status !== "active" &&
        user?.subscription?.status !== "cancelled"))
  ) {
    const redirectPath =
      {
        corporate: "/corporate/subscriptions",
        professional: "/professional/subscriptions",
        user: "/user/subscriptions",
      }[userRole] || "/";

    return <Navigate to={redirectPath} />;
  }

  return children;
};

export default ProtectedRoute;
